import { render } from "./BlankLayoutHeader.vue?vue&type=template&id=017f0639"
const script = {}
script.render = render

export default script